body {
    font-family: 'Golos Text Regular'
}

.h4{
    font-family: 'Golos Text Semibold'
}

@import url("https://p.typekit.net/p.css?s=1&k=sue6ddf&ht=tk&f=139.140.175.176&a=69155722&app=typekit&e=css");

@font-face {
    font-family: "proxima-nova";
    src: url("https://use.typekit.net/af/5be242/00000000000000007735e603/31/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff2"), url("https://use.typekit.net/af/5be242/00000000000000007735e603/31/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff"), url("https://use.typekit.net/af/5be242/00000000000000007735e603/31/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("opentype");
    font-display: auto;
    font-style: normal;
    font-weight: 700;
    font-stretch: normal;
}

@font-face {
    font-family: "proxima-nova";
    src: url("https://use.typekit.net/af/38ea3a/00000000000000007758cf7d/31/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("woff2"), url("https://use.typekit.net/af/38ea3a/00000000000000007758cf7d/31/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("woff"), url("https://use.typekit.net/af/38ea3a/00000000000000007758cf7d/31/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("opentype");
    font-display: auto;
    font-style: italic;
    font-weight: 700;
    font-stretch: normal;
}

@font-face {
    font-family: "proxima-nova";
    src: url("https://use.typekit.net/af/d7ff92/00000000000000007735e609/31/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff2"), url("https://use.typekit.net/af/d7ff92/00000000000000007735e609/31/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff"), url("https://use.typekit.net/af/d7ff92/00000000000000007735e609/31/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("opentype");
    font-display: auto;
    font-style: normal;
    font-weight: 400;
    font-stretch: normal;
}

@font-face {
    font-family: "proxima-nova";
    src: url("https://use.typekit.net/af/6eb0e3/00000000000000007758cf8f/31/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3") format("woff2"), url("https://use.typekit.net/af/6eb0e3/00000000000000007758cf8f/31/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3") format("woff"), url("https://use.typekit.net/af/6eb0e3/00000000000000007758cf8f/31/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3") format("opentype");
    font-display: auto;
    font-style: italic;
    font-weight: 400;
    font-stretch: normal;
}

@font-face {
    font-family: "proxima-nova";
    src: url("https://use.typekit.net/af/26f7ec/00000000000000007735e605/31/l?subset_id=2&fvd=n5&v=3") format("woff2"), url("https://use.typekit.net/af/26f7ec/00000000000000007735e605/31/d?subset_id=2&fvd=n5&v=3") format("woff"), url("https://use.typekit.net/af/26f7ec/00000000000000007735e605/31/a?subset_id=2&fvd=n5&v=3") format("opentype");
    font-display: auto;
    font-style: normal;
    font-weight: 500;
    font-stretch: normal;
}

@font-face {
    font-family: "proxima-nova";
    src: url("https://use.typekit.net/af/e37e5a/00000000000000007735e60d/31/l?subset_id=2&fvd=n6&v=3") format("woff2"), url("https://use.typekit.net/af/e37e5a/00000000000000007735e60d/31/d?subset_id=2&fvd=n6&v=3") format("woff"), url("https://use.typekit.net/af/e37e5a/00000000000000007735e60d/31/a?subset_id=2&fvd=n6&v=3") format("opentype");
    font-display: auto;
    font-style: normal;
    font-weight: 600;
    font-stretch: normal;
}

.tk-proxima-nova {
    font-family: "proxima-nova", sans-serif;
}

/*overwrite breadcrumb partial styles*/
.container-breadcrumb{
    padding-left: 0!important;
    padding-right: 0!important;
    margin: 0!important;
    background-color: white!important;
    border-bottom: 1px solid #e6e6e6!important;
    max-width: unset!important;
    display: flex;
    justify-content: center;
}

.breadcrumbPage{
    padding-left: 15px!important;
    padding-right: 15px!important;
    width:100%;
    max-width: 1440px;
}

.purchase-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.purchase-app-container {
    flex-grow: 1;
    min-height: calc(100vh - 160px);
    width: 100%;
    align-self: stretch;
    background-color: #F1F1F1;
}

.purchase-app-container .product-select-container{
    padding-left: 32px;
    padding-right: 32px;
}

.purchase-all-products-section {
    background-color: #F1F1F1;
    width: 100%;
    align-self: stretch;
}

.purchase-all-products-inner {
    width: 100%;
    max-width: 1440px;
    min-width: 0;
    margin: 0 auto;
    padding: 16px 32px 64px;
    box-sizing: border-box;
    background-color: #F1F1F1;
    overflow-x: hidden;
}

@media screen and (max-width: 992px) {
    .purchase-all-products-inner {
        padding-left: 16px;
        padding-right: 16px;
    }
}

@media screen and (max-width: 500px) {
    .purchase-all-products-inner {
        padding-left: 8px;
        padding-right: 8px;
        padding-bottom: 48px;
    }
}

.purchase-container.purchase-select-host-section {
    background-color: #F1F1F1 !important;
}

.purchase-select-host-section {
    background-color: #F1F1F1 !important;
    width: 100%;
    align-self: stretch;
}

.purchase-select-host-section .product-select-container {
    background-color: #F1F1F1 !important;
    /* ~25% less top padding than sides block (was 64px all around) */
    padding: 48px 32px 64px !important;
    box-sizing: border-box;
    width: 100%;
}

@media screen and (max-width: 992px) {
    .purchase-select-host-section .product-select-container {
        padding-left: 16px !important;
        padding-right: 16px !important;
    }
}

@media screen and (max-width: 500px) {
    .purchase-select-host-section .product-select-container {
        padding-left: 8px !important;
        padding-right: 8px !important;
        padding-bottom: 48px !important;
    }
}

.purchase-container-hub{
    margin-bottom: 64px;
}

.upsell-modal {
    padding: 0 !important;
}

h1,
h2,
h3,
h4,
h5,
h6 {
    font-family: 'Golos Text SemiBold';
}

.product-nav {
    background-color: #2e2f30;
    height: 105px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.product-nav-new {
    background-color: #FCFCFC;
    width: 424px;
    padding-top: 40px;
    padding-left: 150px;
    padding-right: 24px;
}

.product-nav-toggle-chevron {
    width: 16px;
    height: 16px;
}

.product-purchase-nav-items {
    list-style-type: none;
    padding: 0;
    margin: 0;
}

.product-purchase-nav-item-container {
    width: 250px;
}

.product-purchase-nav-item {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 12px;
}

.product-purchase-nav-item-text {
    font-family: 'proxima-nova', serif;
    text-transform: uppercase;
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 0px;
    margin-left: 2px;
}

.product-purchase-nav-item.selected {
    display: flex;
    align-items: center;
    width: 250px;
    padding: 12px;
    background-color: rgba(0, 0, 0, 0.03);
    border: 1px solid #E5E5E5;
    border-radius: 8px;
}

.product-purchase-nav-item img {
    height: 40px;
    width: auto;
}

.product-nav-section-head {
    display: flex;
    justify-content: space-between;
}

.product-nav-section h3 {
    color: rgba(0, 0, 0, 0.65);
    text-align: center;
    font-family: "Golos Text";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 17px;
    /* 121.429% */
    text-transform: uppercase;
    font-size: 14px;
}

/*
.product-family-box{
    width: 128px;
    height: 64px;
    border-radius: 16px;
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid rgba(255, 255, 255, 25%);
    margin: 0 3px;
}

.product-family-box:hover{
    border: 2px solid rgba(255, 255, 255, .5)
}

.product-family-box.suite{
    width: 164px;
}

.product-family-box.selected{
    background-color: #ffffff;
    color: #000000;
}

.product-family-box-logo{
    height: 32px;
    width: 32px;
}

.product-family-box-logo.suite{
    width:140px;
    height: 36px;
}

.product-family-box-container{
    position:relative;
}

.product-family-best-value-box{
    min-width: 94px;
    background-color:#157AFF;
    color:white;
    position:absolute;
    border-radius: 31px;
    left: 54px;
    top: -18px;
    text-align: center;
    padding: 0 8px;
    font-size: 14px;
}
*/

.host-selection-container{
    margin-bottom: 40px;
}

.host-selection-top{
    display: flex;
    justify-content: space-between;
}

.host-selection-header {
    font-size: 20px;
    font-weight: 600;
    line-height: 32px;
    margin-left: 8px;
    margin-bottom: 16px;
}

.purchase-app-container .host-selection-header {
    margin-left: unset;
    font-family: 'Golos Text Regular';
}

.purchase-app-container .product-select-container {
    width: 100%;
    max-width: 1440px;
}

.purchase-app-container .single-product-logo{
    margin-bottom: 24px;
    width: 100%;
}

.purchase-app-container .single-product-logo img {
    height: 48px;
    width: auto;
}

.mobile-product-logo{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;

}

.host-option-container {
    margin-bottom: 8px;
    width: 100%;
}

.host-option-content {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.host-option {
    background-color: #ffffff;
    border: 1px solid #0000001f;
    padding: 12px;
    height: 80px;
    border-radius: 12px;
}

.host-radio-button {
    height: 16px;
    padding-right: 16px;
}

.type-radio-button {
    height: 16px;
    padding-right: 8px;
}

.host-option.selected {
    border-color: #0BAEFF;
    background-color: #FAFDFF;
}

.host-price {
    flex-grow: 1;
    text-align: right;
}

.host-price span {
    text-align: right;
    flex-shrink: 1;
}

.host-price-text {
    font-size: 20px;
    font-weight: 600;
    line-height: 32px;
}

.host-discount-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}

.host-discount-container div {
    margin-left: auto;
}

.host-price-discount {
    font-family: 'Golos Text Regular';
    font-size: 20px;
    line-height: 24px;
    color: #FF3611;
    padding: 0 8px;
    vertical-align: middle;
}

.host-list-price-monthly,
.host-list-price-annual {
    font-size: 16px;
    margin-right: 8px;
    color: rgba(0, 0, 0, 87%)
}

.host-list-price-annual {
    text-decoration: line-through;
}

.host-list-price-monthly {
    font-size: 16px;
}

.host-description {
    padding-left: 6px;
}

.host-description-text {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
}

.purchase-app-container .host-description-text {
    font-family: 'Golos Text Regular';
    font-weight: 600;
}

.host-icon {
    height: 56px;
    width: 56px;
    border-radius: 100%;
}

.host-icon-rest {
    position: relative;
    left: -20px;
}

.host-icon-first {
    position: absolute;
}

.product-options-top {
    display: flex;
    justify-content: space-between;
}

.product-options-row,
.product-options-column {
    margin-bottom: 24px;
}

.product-options-header {
    text-align: center;
    width: 350px;
    font-size: 20px;
    font-weight: 600;
    line-height: 32px;
    margin-bottom: 16px;
}

.purchase-app-container .product-options-header {
    text-align: unset;
    font-family: 'Golos Text Regular';
    flex-grow: 1;
}

.purchase-app-container.single-product-app {
    justify-content: center;
}

.product-option-pills {
    display: flex;
    gap: 8px;
}

.product-options-row .product-options-pill {
    width: 100%;
    display: flex;
}

.product-options-pill button {
    display: flex;
    align-items: center;
    background-color: #ffffff;
    border: 1px solid rgba(0, 0, 0, 12%);
    padding: 12px;
    height: 48px;
    outline: unset;
    cursor: pointer;
    font-family: 'Golos Text Regular';
}

.product-options-pill .selected {
    background-color: #FAFDFF;
    border-color: #0BAEFF;
    cursor: unset;
}

.product-options-pill .full-option {
    border-radius: 8px;
}

.product-options-pill .pill-text {
    font-size: 14px;
    line-height: 16px;
    font-weight: 600;
    display: block;
}

.product-options-pill .pill-subtext {
    font-size: 14px;
    line-height: 16px;
    font-weight: 400;
    display: block;
}

.purchase-serial-select-container label {
    width: 100%;
    max-width: 350px;
    text-align: center;
    font-family: "Golos Text SemiBold";
    font-size: 22px;
    font-weight: 700;
    line-height: 32px;
    margin-bottom: 16px;
}

.purchase-serial-select {
    width: 334px;
    font-family: 'Golos Text Regular';
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.5px;
    border: 1px solid rgba(0, 0, 0, 12%);
    border-radius: 8px;
    padding: 12px 16px;
    margin-bottom: 16px;
    box-sizing: content-box;
    height: 22px !important;
    background: url(https://borisfx.com/svgs/select-arrow.svg) no-repeat right white;
    -webkit-appearance: none;
}

.purchase-serial-select-support {
    color: rgba(0, 0, 0, .85);
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
}

.purchase-bar {
    height: 64px;
    width: 100%;
    bottom: 0;
    background-color: #ffffff;
    border-top: 1px solid rgba(0, 0, 0, 12%);
    z-index: 999;
    padding: 8px 0;
}

.purchase-bar-float{
    position: fixed;
    bottom: 0;
    z-index: 998;
}

#purchase-app-full .purchase-bar {
    height: 70px;
    padding: 8px 0;
}

.purchase-bar-content {
    height: 100%;
    max-width: 1440px;
    padding: 0 32px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.purchase-bar-text {
    font-size: 16px;
    line-height: 16px;
    font-weight: 600;
    margin-right: 16px;
}

.purchase-bar-end {
    display: flex;
    align-items: center;
    gap: 32px;
    margin-left: 24px;
}

.purchase-bar-continue{
    display: flex;
    gap: 8px;
}

.purchase-bar-subprice {
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
}

.purchase-bar-price {
    vertical-align: middle;
    font-size: 20px;
    font-weight: 600;
}

.purchase-bar-discount {
    color: #FF3611;
    font-family: 'Golos Text Semibold';
    font-size: 24px;
    line-height: 28px;
    padding-right: 8px;
    vertical-align: bottom;
}

.purchase-bar-list-price {
    vertical-align: middle;
    text-decoration-line: line-through;
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    letter-spacing: .3px;
    color: rgba(0, 0, 0, 87%);
    margin-right: 8px;
}

.purchase-bar-prices{
    text-align: right;
}

.purchase-bar-price-discount {
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
    color: #F2545B;
    background-color: #F2545B20;
    border-radius: 32px;
    padding: 0 8px;
    vertical-align: middle;
}

.purchase-bar-price-lg {
    font-size: 20px;
    line-height: 32px;
    font-weight: 600;
    vertical-align: middle;
}

.purchase-bar-btn {
    border-radius: 6px;
    height: 54px!important;
    padding: 15px 30px!important;
    margin: 0;
    font-size: 20px;
    font-weight: 600px;
    font-family: 'Golos Text Regular';
    line-height: 24px;
}

.purchase-bar-btn:hover{
    background-color: #33BEF2!important;
    color: unset!important;
}

.purchase-bar-btn:focus{
    background-color: #008BBF!important;
}

.purchase-bar-btn:disabled{
    background-color: #94C8DB;
    color: #939A9C;
}

.btn-new-secondary.purchase-bar-btn:hover{
    background-color: #cfcfcf!important;
}

.btn-new-secondary.purchase-bar-btn:focus{
    background-color: #8A8A8A!important;
}

.btn-new-secondary.purchase-bar-btn:disabled {
    background-color: rgba(0, 0, 0, 0.05);
}

.purchase-bar-image {
    height: 40px;
    width: auto;
}

#purchase-app-full .purchase-bar-image {
    height: 40px;
    width: auto;
}

.quantity-field label {
    font-size: 14px;
    font-family: 'Golos Text Regular';
    font-weight: 400;
    line-height: 16px;
    letter-spacing: .3px;
}

.quantity-field select {
    width: 64px;
    height: 32px;
    font-size: 14px;
    text-align: left;
    font-weight: 400;
    line-height: normal;
    border: 1px solid #D0D0D0;
    border-radius: 4px;
    margin-left: 8px;
    padding: 6px 12px 6px 12px;
    background: url(https://borisfx.com/svgs/select_arrow_new.svg) no-repeat right white;
    background-position: 32px;
    -webkit-appearance: none;
    -moz-appearance:none;
    appearance: none;
}

.purchase-bar-currency-label{
    font-size: 14px;
    font-family: 'Golos Text Regular';
    font-weight: 400;
    line-height: 16px;
    letter-spacing: .3px;
    margin: 0;
}

@media screen and (max-width: 1192px) {
    .product-nav {}

    .product-family-box {
        width: 100px;
    }
}

@media screen and (max-width: 1192px) {
    .product-nav {
        flex-wrap: wrap;
        height: 25vh;
    }

    .product-family-box {
        width: 100px;
    }

    .purchase-bar {
        padding: 12px 32px;
    }

    .purchase-bar, .purchase-bar-content{
        height: unset!important;
    }

    .purchase-bar-content{
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: repeat(3, max-content);
        grid-column-gap: 0px;
        grid-row-gap: 16px;
        margin: 8px 16px;
    }
    
    .purchase-bar-quantity { grid-area: 1 / 1 / 2 / 2; }
    .purchase-bar-currency { 
        justify-self: flex-end;
        grid-area: 1 / 2 / 2 / 3; 
    }
    .purchase-bar-prices { grid-area: 2 / 2 / 3 / 3; }
    .purchase-bar-money-back { 
        grid-area: 2 / 2 / 3 / 1; 
        align-self: flex-end;
    }
    .purchase-bar-continue { 
        grid-area: 3 / 1 / 4 / 3; 
        justify-content: space-between;
        gap: 16px;
    }

    .money-back-container{
        width: 165px!important;
    }

    .purchase-bar-btn.btn-new-dynamic{
        padding: 15px 30px!important;
        height: unset!important;
        width: 100%!important;
    }
}

@media screen and (max-width: 992px) {
    .product-nav {
        height: 35vh;
        flex-wrap: nowrap;
        white-space: nowrap;
        min-width: max-content;
    }

    .mobile-nav-close-button{
        display: flex;
        justify-content: flex-end;
        width: 100%;
        padding-top: 16px;
        padding-bottom: 24px;
    }

    .product-nav-new{
        position: fixed;
        z-index: 999;
        top: 64px;
        width: 100vw;
        height: 100%;
        padding: 0 8px;
        overflow-y: auto;
    }

    .product-select-container{
        padding-right: 16px!important;
        padding-left: 16px!important;
    }

    .product-family-box {
        height: 10vh;
        width: 7.5vw;
        min-width: 75px;
        font-size: .75rem;
    }

    .product-family-box.suite {
        height: 10vh;
        width: 15vw;
        min-width: 150px;
        font-size: .75rem;
    }

    .container {
        margin: 0;
        min-width: 100%;
    }

    .single-product-logo{
        margin-bottom: 2px!important;
    }

    .product-option-pills-container{
        width: 100%;
        overflow-x: auto;
    }

    .product-option-pills{
        width: max-content;
    }

    .product-options-pill{
        padding: 4px;
    }

    .product-options-pill button{
        padding: 4px;
    }

    .host-selection-top{
        flex-direction: column;
        justify-content: unset;
    }

    .host-selection-top .subscription-toggle-container{
        order: 1;
    }

    .host-selection-top h4{
        order: 2;
    }

    .host-option {
        height: unset;
    }

    .host-description{
        order: 2;
        flex-basis: 100%;
    }

    .host-price{
        order: 1;
    }

    .host-price span {
        font-size: 16px;
        line-height: unset;
        padding-left: 6px;
    }

    .purchase-bar{
        height: unset!important;
    }

    .purchase-bar-content{
        flex-wrap: wrap;
        margin: 0 16px;
        padding: 0;
    }
    

    .purchase-bar-end{
        flex-basis: 100%;
        display:flex;
        gap: 8px;
        flex-direction: column;
        align-items: flex-end;
        margin: 0;
    }

    .purchase-bar-money-back{
        width: 100%;
        align-items: center;
        display: flex;
        justify-content: space-between;
    }
}

@media screen and (max-width: 768px) {
    .purchase-bar-continue{
        flex-direction: column;
    }
    
    .product-nav {
        height: 35vh;
        flex-wrap: wrap;
        white-space: unset;
        min-width: unset;
        padding-top: 20px;
    }

    .purchase-bar {
        padding: 12px 16px;
    }
}

@media screen and (max-width: 768px) and (max-height: 450px) {
    .product-nav {
        height: 40vh
    }
}

@media screen and (max-width: 450px) {
    .product-nav {
        min-height: max-content;
        height: auto;
        flex-wrap: wrap;
        white-space: unset;
        min-width: unset;
        padding: 20px 0;
    }

    .product-family-box-container {
        margin-bottom: 4px;
    }

    .product-family-best-value-box {
        display: none;
    }
    
    .host-price {
        justify-content: flex-start;
    }

    .host-description {
        padding-right: 16px;
    }

    .purchase-bar {
        height: 250px;
    }

    .purchase-bar-prices {
        flex-grow: 1;
    }

    .host-selection-container {
        padding: 0;
    }

    .product-options-container {
        padding: 0;
    }

}

/*
 * Zendesk offset: PurchaseBar sets --bfx-sticky-purchase-bar-height and lifts the widget via JS
 * (fixed wrapper + sibling “Need any help” iframe), so we don’t transform individual iframes here.
 */